import { visibleTargets } from '@/lib/map/targetVisibility';
/**
 * Which RF-detected drones (ENG-253) the map should currently show — shared
 * by the operator markers and the operator→drone link layer. Same rule as the
 * target markers (lib/map/targetVisibility.ts), narrowed to RF targets.
 */
import type { Target } from '@/lib/mqtt/schemas/targets';
import { useSurvStore } from '@/lib/store/surv';
import { useUiStore } from '@/lib/store/ui';

export function rfTargetsToShow(): Target[] {
  return visibleTargets().filter((t) => t.rf !== null);
}

/** Store fields that change which RF targets are shown. */
export const rfVisibilityKey = () => {
  const s = useSurvStore.getState();
  return `${useUiStore.getState().activeContext}|${s.mode}|${s.selectedNetwork}|${s.fusedService ? 1 : 0}|${s.fusedSelected.join(',')}|${Object.keys(s.byId).length}`;
};
